import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import styled from "styled-components";
import { Box, Dropdown, Flex, Text, DatePicker } from "samba-ui";
import { loadCampaigns } from "../api";

const DisabledBox = styled(Box)`
  opacity: 0.5;
  pointer-events: none;
`;

const CampaignSelector = ({ selectedCampaignAndDate, type }) => {
  const [campaigns, setCampaigns] = useState(null);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [dropDownOptions, setDropDownOptions] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [selectedCampaignId, setSelectedCampaignId] = useState(null);
  const [
    selectedCampaignIdDropdownOptions,
    setSelectedCampaignIdDropdownOptions
  ] = useState([]);

  useEffect(() => {
    const req = async () => {
      const res = await loadCampaigns(type);
      const { data } = await res.json();
      setCampaigns(data);

      // remove the duplicated campaigns
      let options = Object.values(data).reduce((acc, c) => {
        acc[c.campaignName] = c;
        return acc;
      }, {});

      options = Object.keys(options).map(key => ({
        label: key,
        value: options[key].id
      }));
      setDropDownOptions(options);
    };
    req();
  }, [type]);

  const onCampaignSelect = selected => {
    const campaign = campaigns[selected.value];
    let campaignIds = Object.values(campaigns).filter(
      campaign => campaign.campaignName === selected.label
    );
    const campaignIdDropdownOptions = campaignIds.map(c => ({
      label: c.id,
      value: c.id
    }));

    setSelectedCampaignIdDropdownOptions(campaignIdDropdownOptions);
    setSelectedCampaignId(campaignIdDropdownOptions[0]);

    setSelectedCampaign(selected);
    const campaignStartDate = moment(campaign.startDate, "YYYYMMDD");
    setStartDate(campaignStartDate);
    const campaignEndDate = moment(campaign.endDate, "YYYYMMDD");
    setEndDate(campaignEndDate);
  };

  const onCampaignEndDateSelected = selected => {
    setSelectedEndDate(selected);
    selectedCampaignAndDate({
      campaignTableId: selectedCampaignId.value,
      campaignName: selectedCampaign.label,
      endDate: selected.format("YYYY-MM-DD")
    });
  };

  return (
    <Box>
      <Flex my={2} alignItems="center" justifyContent="space-between">
        <Text>Select a campaign:</Text>
        <Box width={300}>
          <Dropdown
            options={dropDownOptions}
            selected={selectedCampaign}
            onSelect={onCampaignSelect}
          />
        </Box>
      </Flex>
      {selectedCampaign && (
        <Flex my={2} alignItems="center" justifyContent="space-between">
          <Text>Select a campaign id:</Text>
          <Box width={300}>
            <Dropdown
              options={selectedCampaignIdDropdownOptions}
              selected={selectedCampaignId}
              onSelect={setSelectedCampaignId}
            />
          </Box>
        </Flex>
      )}
      {selectedCampaign && startDate ? (
        <Flex my={2} alignItems="center" justifyContent="space-between">
          <Text>Set End date for the campaign</Text>
          <Flex justifyContent="space-between" width={500}>
            <DisabledBox>
              <DatePicker
                selectedDate={startDate}
                minDate={startDate}
                maxDate={startDate}
              />
            </DisabledBox>
            <DatePicker
              selectedDate={selectedEndDate}
              minDate={startDate ? moment(startDate).add(1, "day") : null}
              maxDate={endDate}
              onChooseDate={onCampaignEndDateSelected}
            />
          </Flex>
        </Flex>
      ) : null}
    </Box>
  );
};

CampaignSelector.propTypes = {
  selectedCampaignAndDate: PropTypes.func,
  type: PropTypes.string.isRequired
};

export default CampaignSelector;
